var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"message-overlay"},[_c('div',{staticClass:"message-container"},[_c('div',{staticClass:"message-content"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }